import React from 'react';

const Notfound = () => {
  return (
    <div>
      <h1 className='lead'>Page You are looking for doesn't exist</h1>
    </div>
  );
};

export default Notfound;
